<template>
  <ui-combobox-select
    :model-value="modelValue"
    :options="options"
    option-value="id"
    :option-label="(brand) => brand.id === null ? tr('All brands') : brand.name"
    :placeholder="placeholder || tr('Select Brand')"
    :search-placeholder="tr('Search') + '...'"
    :empty-text="tr('No results')"
    :disabled="disabled"
    @update:model-value="(value) => $emit('update:modelValue', value)"
  >
    <template #option="{ option, label }">
      <social-page
        v-if="option.id !== null"
        :source-profiles="option.sourceProfiles"
        only-icon
        small
        class="mr-1 shrink-0"
      />
      <span class="truncate">{{ label }}</span>
      <ui-badge v-if="option.is_active === false" variant="secondary">
        {{ tr('brand.inactive') }}
      </ui-badge>
    </template>
  </ui-combobox-select>
</template>

<script>
import SocialPage from '@/ui/components/SocialPage.vue';

/**
 * Brand picker of the current company. As a list filter it starts with an
 * "All brands" (null) option; without `allOption` it is a plain picker.
 */
export default {
  name: 'BrandFilter',
  components: {
    SocialPage,
  },
  props: {
    modelValue: {
      type: [ String, Number, null ],
      required: false,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    allOption: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    // Inactive brands are left out unless allowed.
    allowInactive: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    excludeIds: {
      type: Array,
      required: false,
      default: () => [],
    },
    placeholder: {
      type: String,
      required: false,
      default: () => '',
    },
  },
  emits: [ 'update:modelValue' ],
  computed: {
    options() {
      const brands = (this.$root.currentCompany?.brands || [])
        .filter(brand => !this.excludeIds.includes(brand.id))
        .filter(brand => this.allowInactive || brand.is_active !== false);

      return this.allOption ? [ { id: null }, ...brands ] : brands;
    },
  },
};
</script>
